import { ChainId } from '@ourzora/chains'
import { contracts1155 } from '@zoralabs/protocol-deployments'
import base721 from '@zoralabs/zora-721-contracts/addresses/8453.json'
import arbitrum721 from '@zoralabs/zora-721-contracts/addresses/42161.json'
import { Address, getAddress, zeroAddress } from 'viem'
// 721 Addresses
import mainnet721 from '../vendor/addresses/721/1.json'
import optimism721 from '../vendor/addresses/721/10.json'
import baseSepolia721 from '../vendor/addresses/721/84532.json'
import zora721 from '../vendor/addresses/721/7777777.json'
import sepolia721 from '../vendor/addresses/721/11155111.json'
import zoraSepolia721 from '../vendor/addresses/721/999999999.json'

export * from './erc20'
export type LowercaseAddress = Lowercase<Address>

const mainnet1155 = contracts1155.addresses[1]
const arbitrum1155 = contracts1155.addresses[42161]
const base1155 = contracts1155.addresses[8453]
const baseSepolia1155 = contracts1155.addresses[84532]
const zora1155 = contracts1155.addresses[7777777]
const sepolia = contracts1155.addresses[11155111]
const zoraSepolia1155 = contracts1155.addresses[999999999]
const optimism1155 = contracts1155.addresses[10]

const PROTOCOL_REWARDS = cleanAddress('0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B')

// TODO: This will be imported from @zoralabs/protocol-deployments in future
const ERC20_MINTER = '0x777777E8850d8D6d98De2B5f64fae401F96eFF31'

export function cleanAddress(address: string) {
  return getAddress(address).toLowerCase() as LowercaseAddress
}

type MultichainAddressMap<T = LowercaseAddress> = Record<ChainId, T>

type ContractAddressMap = {
  ERC20_FACTORY: MultichainAddressMap
  ZORA_1155: {
    CONTRACT_VERSION: MultichainAddressMap<string>
    ZORA_TIMED_SALE_STRATEGY: MultichainAddressMap
    FIXED_PRICE_SALE_STRATEGY: MultichainAddressMap
    MERKLE_MINT_SALE_STRATEGY: MultichainAddressMap
    ERC20_MINTER: MultichainAddressMap
    FACTORY_PROXY: MultichainAddressMap
    PREMINTER: MultichainAddressMap
  }
  ZORA_721: {
    CONTRACT_VERSION: MultichainAddressMap<string>
    DROP_METADATA_RENDERERS: MultichainAddressMap<LowercaseAddress[]>
    EDITION_METADATA_RENDERERS: MultichainAddressMap<LowercaseAddress[]>
    FACTORY_PROXY: MultichainAddressMap
  }
  OPERATOR_FILTER_ADDRESS: MultichainAddressMap
  SUPER_ADMINS: MultichainAddressMap<LowercaseAddress[]>
  JSON_EXTENSION_REGISTRY: MultichainAddressMap
  ZORA_REWARDS: MultichainAddressMap<LowercaseAddress[]>
}

export const SUPER_ADMINS: LowercaseAddress[] = [
  '0x4492ecacb5da5d933af0e55eedad4383bf8d2db5',
  '0x83efc260da533b0b03d88b2f00d59785277c4e71',
  '0x24e5b063fbfa23a168148d102a239c139ad83cc7',
  '0x256e018101dedc1b386c8719fc8bf56c733dfa28',
  '0xf7b2c2eb58a5f801119df7e9bf9f9b66c62bb011',
  '0x85a58d1a453a5e658bba7a2b5cca3fa64a5e20b1',
  '0xf14116ba409718457f09e6cb906467ef7f2e3622',
  '0xe1c2d8b29ad2f942c54eac0bbfc8375addc100ea',
  '0x4ffac8b63293599172a5a8c89916916352385620',
]

const OPERATOR_FILTER_ADDRESS = cleanAddress('0x000000000000AAeB6D7670E522A718067333cd4E')

const JSON_EXTENSION_REGISTRY = cleanAddress('0xabcdefed93200601e1dfe26d6644758801d732e8')

export const LEGACY_PROTOCOL_REWARDS = [
  cleanAddress('0x7777777A456fF23D9b6851184472c08FBDa73e32'),
]

export const addresses: ContractAddressMap = {
  ERC20_FACTORY: {
    1: zeroAddress,
    11155111: zeroAddress,
    10: zeroAddress,
    7777777: zeroAddress,
    8453: cleanAddress('0x997020E5F59cCB79C74D527Be492Cc610CB9fA2B'),
    84532: cleanAddress('0x04870e22fa217Cb16aa00501D7D5253B8838C1eA'),
    999999999: zeroAddress,
    42161: zeroAddress,
  },
  ZORA_1155: {
    CONTRACT_VERSION: {
      1: mainnet1155.CONTRACT_1155_IMPL_VERSION,
      11155111: sepolia.CONTRACT_1155_IMPL_VERSION,
      10: optimism1155.CONTRACT_1155_IMPL_VERSION,
      7777777: zora1155.CONTRACT_1155_IMPL_VERSION,
      8453: base1155.CONTRACT_1155_IMPL_VERSION,
      84532: baseSepolia1155.CONTRACT_1155_IMPL_VERSION,
      999999999: zoraSepolia1155.CONTRACT_1155_IMPL_VERSION,
      42161: arbitrum1155.CONTRACT_1155_IMPL_VERSION,
    },
    ZORA_TIMED_SALE_STRATEGY: {
      1: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
      11155111: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
      10: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
      7777777: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
      8453: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
      84532: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
      999999999: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
      42161: cleanAddress('0x777777722D078c97c6ad07d9f36801e653E356Ae'),
    },
    FIXED_PRICE_SALE_STRATEGY: {
      1: cleanAddress(mainnet1155.FIXED_PRICE_SALE_STRATEGY),
      11155111: cleanAddress(sepolia.FIXED_PRICE_SALE_STRATEGY),
      10: cleanAddress(optimism1155.FIXED_PRICE_SALE_STRATEGY),
      7777777: cleanAddress(zora1155.FIXED_PRICE_SALE_STRATEGY),
      8453: cleanAddress(base1155.FIXED_PRICE_SALE_STRATEGY),
      84532: cleanAddress(baseSepolia1155.FIXED_PRICE_SALE_STRATEGY),
      999999999: cleanAddress(zoraSepolia1155.FIXED_PRICE_SALE_STRATEGY),
      42161: cleanAddress(arbitrum1155.FIXED_PRICE_SALE_STRATEGY),
    },
    MERKLE_MINT_SALE_STRATEGY: {
      1: cleanAddress(mainnet1155.MERKLE_MINT_SALE_STRATEGY),
      11155111: cleanAddress(sepolia.MERKLE_MINT_SALE_STRATEGY),
      10: cleanAddress(optimism1155.MERKLE_MINT_SALE_STRATEGY),
      7777777: cleanAddress(zora1155.MERKLE_MINT_SALE_STRATEGY),
      8453: cleanAddress(base1155.MERKLE_MINT_SALE_STRATEGY),
      84532: cleanAddress(baseSepolia1155.MERKLE_MINT_SALE_STRATEGY),
      999999999: cleanAddress(zoraSepolia1155.MERKLE_MINT_SALE_STRATEGY),
      42161: cleanAddress(arbitrum1155.MERKLE_MINT_SALE_STRATEGY),
    },
    ERC20_MINTER: {
      1: cleanAddress(ERC20_MINTER),
      11155111: cleanAddress(ERC20_MINTER),
      10: cleanAddress(ERC20_MINTER),
      7777777: cleanAddress(ERC20_MINTER),
      8453: cleanAddress(ERC20_MINTER),
      84532: cleanAddress(ERC20_MINTER),
      999999999: cleanAddress(ERC20_MINTER),
      42161: cleanAddress(ERC20_MINTER),
    },
    FACTORY_PROXY: {
      1: cleanAddress(mainnet1155.FACTORY_PROXY),
      11155111: cleanAddress(sepolia.FACTORY_PROXY),
      10: cleanAddress(optimism1155.FACTORY_PROXY),
      7777777: cleanAddress(zora1155.FACTORY_PROXY),
      8453: cleanAddress(base1155.FACTORY_PROXY),
      84532: cleanAddress(baseSepolia1155.FACTORY_PROXY),
      999999999: cleanAddress(zoraSepolia1155.FACTORY_PROXY),
      42161: cleanAddress(arbitrum1155.FACTORY_PROXY),
    },
    PREMINTER: {
      1: cleanAddress(zeroAddress),
      11155111: cleanAddress(zeroAddress),
      10: cleanAddress(zeroAddress),
      7777777: cleanAddress(zora1155.PREMINTER_PROXY),
      8453: cleanAddress(zeroAddress),
      84532: cleanAddress(zeroAddress),
      42161: cleanAddress(zeroAddress),
      999999999: cleanAddress(zoraSepolia1155.PREMINTER_PROXY),
    },
  },
  ZORA_721: {
    CONTRACT_VERSION: {
      1: mainnet721.CONTRACT_VERSION,
      11155111: sepolia721.CONTRACT_VERSION,
      10: optimism721.CONTRACT_VERSION,
      7777777: zora721.CONTRACT_VERSION,
      8453: `${base721.ERC721DROP_IMPL_VERSION}`,
      84532: `${baseSepolia721.ERC721DROP_IMPL_VERSION}`,
      999999999: String(zoraSepolia721.ERC721DROP_IMPL_VERSION),
      42161: String(arbitrum721.ERC721DROP_IMPL_VERSION),
    },
    DROP_METADATA_RENDERERS: {
      1: [cleanAddress(mainnet721.DROP_METADATA_RENDERER)],
      11155111: [cleanAddress(sepolia721.DROP_METADATA_RENDERER)],
      10: [cleanAddress(optimism721.DROP_METADATA_RENDERER)],
      7777777: [cleanAddress(zora721.DROP_METADATA_RENDERER)],
      8453: [cleanAddress(base721.DROP_METADATA_RENDERER)],
      84532: [cleanAddress(baseSepolia721.DROP_METADATA_RENDERER)],
      999999999: [cleanAddress(zoraSepolia721.DROP_METADATA_RENDERER)],
      42161: [cleanAddress(arbitrum721.DROP_METADATA_RENDERER)],
    },
    EDITION_METADATA_RENDERERS: {
      1: [
        cleanAddress('0x192ce8267cbab9c3c477d61e85d7f0c5fe3b46af'),
        cleanAddress('0xd167b7a408c65306d5a2abead63986540110b28b'),
        cleanAddress('0xbae11704b019abf8aacd3e6859954277e158716c'),
      ],
      11155111: [cleanAddress(sepolia721.EDITION_METADATA_RENDERER)],
      10: [cleanAddress(optimism721.EDITION_METADATA_RENDERER)],
      7777777: [cleanAddress(zora721.EDITION_METADATA_RENDERER)],
      8453: [cleanAddress(base721.EDITION_METADATA_RENDERER)],
      84532: [cleanAddress(baseSepolia721.EDITION_METADATA_RENDERER)],
      999999999: [cleanAddress(zoraSepolia721.EDITION_METADATA_RENDERER)],
      42161: [cleanAddress(arbitrum721.EDITION_METADATA_RENDERER)],
    },
    FACTORY_PROXY: {
      1: cleanAddress(mainnet721.ZORA_NFT_CREATOR_PROXY),
      11155111: cleanAddress(sepolia721.ZORA_NFT_CREATOR_PROXY),
      10: cleanAddress(optimism721.ZORA_NFT_CREATOR_PROXY),
      7777777: cleanAddress(zora721.ZORA_NFT_CREATOR_PROXY),
      8453: cleanAddress(base721.ZORA_NFT_CREATOR_PROXY),
      84532: cleanAddress(baseSepolia721.ZORA_NFT_CREATOR_PROXY),
      999999999: cleanAddress(zoraSepolia721.ZORA_NFT_CREATOR_PROXY),
      42161: cleanAddress(arbitrum721.ZORA_NFT_CREATOR_PROXY),
    },
  },
  OPERATOR_FILTER_ADDRESS: {
    1: OPERATOR_FILTER_ADDRESS,
    11155111: OPERATOR_FILTER_ADDRESS,
    10: OPERATOR_FILTER_ADDRESS,
    7777777: OPERATOR_FILTER_ADDRESS,
    8453: OPERATOR_FILTER_ADDRESS,
    84532: OPERATOR_FILTER_ADDRESS,
    999999999: OPERATOR_FILTER_ADDRESS,
    42161: OPERATOR_FILTER_ADDRESS,
  },
  SUPER_ADMINS: {
    1: SUPER_ADMINS,
    11155111: SUPER_ADMINS,
    10: SUPER_ADMINS,
    7777777: SUPER_ADMINS,
    8453: SUPER_ADMINS,
    84532: SUPER_ADMINS,
    999999999: SUPER_ADMINS,
    42161: SUPER_ADMINS,
  },
  JSON_EXTENSION_REGISTRY: {
    1: JSON_EXTENSION_REGISTRY,
    11155111: JSON_EXTENSION_REGISTRY,
    10: JSON_EXTENSION_REGISTRY,
    7777777: JSON_EXTENSION_REGISTRY,
    8453: JSON_EXTENSION_REGISTRY,
    84532: JSON_EXTENSION_REGISTRY,
    999999999: JSON_EXTENSION_REGISTRY,
    42161: JSON_EXTENSION_REGISTRY,
  },
  ZORA_REWARDS: {
    1: [...LEGACY_PROTOCOL_REWARDS, PROTOCOL_REWARDS],
    11155111: [...LEGACY_PROTOCOL_REWARDS, PROTOCOL_REWARDS],
    10: [...LEGACY_PROTOCOL_REWARDS, PROTOCOL_REWARDS],
    7777777: [...LEGACY_PROTOCOL_REWARDS, PROTOCOL_REWARDS],
    8453: [...LEGACY_PROTOCOL_REWARDS, PROTOCOL_REWARDS],
    84532: [PROTOCOL_REWARDS],
    999999999: [PROTOCOL_REWARDS],
    42161: [PROTOCOL_REWARDS],
  },
}
